import React from 'react';
import ReactDom from 'react-dom';
import EnquiryForm from './components/Enquiry/EnquiryForm';

[].forEach.call(
    document.querySelectorAll('.enquiry-form'),
    (target) => {
        ReactDom.render(
            <EnquiryForm/>,
            target,
        );
    },
);
